import { ULDInput } from 'src/components/uld-input';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(ULDInput.displayName, ULDInput);

export default ULDInput;

export { ULDInput };
